import React from "react";
import { Box, Typography } from "@mui/material";
import { Check } from "@mui/icons-material";

const STEPS = [
  { number: 1, label: "Upload File" },
  { number: 2, label: "Validate Data" },
  { number: 3, label: "Update Records" },
];

export function StepIndicator({ currentStep }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        maxWidth: "768px",
      }}
    >
      {STEPS.map((step, index) => (
        <React.Fragment key={step.number}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s ease",
                backgroundColor: currentStep > step.number ? "#16A34A" : currentStep === step.number ? "#3B82F6" : "#E5E7EB",
                color: currentStep > step.number || currentStep === step.number ? "white" : "#6B7280",
              }}
            >
              {currentStep > step.number ? (
                <Check style={{ width: 20, height: 20 }} />
              ) : (
                <Typography>{step.number}</Typography>
              )}
            </Box>
            <Typography
              sx={{
                fontSize: "14px",
                color: currentStep >= step.number ? "#111827" : "#6B7280",
                marginLeft: "12px",
              }}
            >
              {step.label}
            </Typography>
          </Box>

          {index < STEPS.length - 1 && (
            <Box
              sx={{
                flex: 1,
                height: "2px",
                marginLeft: "16px",
                marginRight: "16px",
                transition: "background-color 0.3s ease",
                backgroundColor: currentStep > step.number ? "#16A34A" : "#E5E7EB",
              }}
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
}
